import { Grid, Filter, Page, Sort, RecordClickEventArgs, parentsUntil, Toolbar, Edit, QueryCellInfoEventArgs, Column, RowSelectingEventArgs } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { DropDownList, ChangeEventArgs } from '@syncfusion/ej2-dropdowns';
import { DatePicker, DateTimePicker } from '@syncfusion/ej2-calendars';
// import { Toastr } from '../Helpers/Toastr';
// import { UserDataService } from '../DataService/UserDataService';
import { DynamicVariables } from '../../Common/DynamicVariables';
import { Dropdown } from 'bootstrap';
import { WorkloadManagerDataService } from '../../DataService/WorkloadManagerDataService';
import { SyncfusionDropdownHelper } from '../../Helpers/SyncfusionDropdownHelper';
import { TaskStatus } from '../../Models/TaskManager/TaskStatus';
import { TaskLinkTypes } from '../../Models/TaskManager/TaskLinkTypes';
import { DateHelper } from '../../Helpers/DateHelper';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { CheckBox } from '@syncfusion/ej2/buttons';
import { TaskMassAssignPopupManager } from './TaskMassAssignPopupManager';
import { AddOrUpdateTaskPopupManager } from './AddOrUpdateTaskPopupManager';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { TaskManagerDataService } from '../../DataService/TaskManagerDataService';
import { FinishTaskPopupManager } from './FinishTaskPopupManager';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';
// import { ModalHelper } from '../Helpers/ModalHelper';
// import { ConfirmModal } from '../Helpers/ConfirmModal';


export class TaskOverviewManager {

    constructor(private containerElement: JQuery) { }

    private workbookGrid : Grid;

    private massAssignModalHelper : ModalHelper;
    private massAssignManager : TaskMassAssignPopupManager;

    private addOrUpdateTaskModalHelper : ModalHelper;
    private addOrUpdateTaskManager : AddOrUpdateTaskPopupManager;

    private finishTaskModalHelper : ModalHelper;
    private finishTaskManager : FinishTaskPopupManager;


    public initialize() {
        var self = this;

        Grid.Inject(Filter, Page, Sort, Toolbar, Edit);

        self.initializeTasksTable();
    }

    private initializeTasksTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var workloadContainer = self.containerElement.find('#task-container');
        var massAssignButton = self.containerElement.find('#mass-assign-tasks-button');
        var addTaskButton = self.containerElement.find('#add-task-button');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#WorkloadTaskOverviewGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        let data: DataManager = new DataManager({
            url: '/api/company/task/list',
            adaptor: new WebApiAdaptor,
        });

        var creationDateElem;
        var creationDateObj;

        var startDateElem;
        var startDateObj;

        var finishDateElem;
        var finishDateObj;

        var dueDateElem;
        var dueDateObj;

        self.massAssignModalHelper = new ModalHelper();
        self.massAssignModalHelper.createModal("task-mass-assign-popup", true);        
        
        self.addOrUpdateTaskModalHelper = new ModalHelper();
        self.addOrUpdateTaskModalHelper.createModal("add-or-update-task-popup", true);

        self.finishTaskModalHelper = new ModalHelper();
        self.finishTaskModalHelper.createModal("finish-task-popup", true);

        var selectedRowIds = [];

        TaskManagerDataService.getTaskOverviewSelectableItems((result) => {
            var purchasersForFilters = result.operators;
            purchasersForFilters = [{purchaserId: "00000000-0000-0000-0000-000000000000", purchaserName: "<Unassigned>"}].concat(purchasersForFilters);

            var taskTypesForFilters = result.taskTypes;

            self.workbookGrid = new Grid(
            {
                height: '100%',
                toolbarTemplate: '#toolbar-template',
                dataSource: data,
                editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
                columns: [
                    { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                    { field: 'Selected', headerText: '', allowFiltering: true, allowEditing: false, width:20, template: '${getTaskItemCheckbox(data.Id)}',
                        filterBarTemplate: {
                            create: () => { 
                                var newCheckbox = document.createElement("input");
                                newCheckbox.type = "checkbox";
                                newCheckbox.style.width = '13px';
                                newCheckbox.style.height = '13px';
                                newCheckbox.style.marginTop = '0.25rem';

                                var parsedCheckbox = $(newCheckbox);
                                parsedCheckbox.off('change').on('change', () => {
                                    var checked = parsedCheckbox.is(':checked');
                                    
                                    workloadContainer.find(`input[data-item-id]`).each((index, element) => {
                                        var parsedCheckboxElement = $(element);
                                        var itemId = parsedCheckboxElement.data('item-id');

                                        parsedCheckboxElement.prop('checked', checked); 

                                        if(checked) {
                                            if(selectedRowIds.indexOf(itemId) == -1) {
                                                selectedRowIds.push(itemId);
                                            }
                                        }
                                        else {
                                            const index = selectedRowIds.indexOf(itemId);
                                            if (index > -1) {
                                                selectedRowIds.splice(index, 1); // 2nd parameter means remove one item only
                                            }
                                        }
                                    });

                                    if(checked) {
                                        massAssignButton.prop('disabled', false); 
                                    }
                                    else {
                                        if(selectedRowIds.length <= 0) {
                                            massAssignButton.prop('disabled', true);
                                        }
                                    }
                                })

                                return newCheckbox;
                                }, 
                                write: (args) => { 

                                } 
                        }
                    },
                    { field: 'CreationDateTimeString', headerText: 'Date',  width: 75, allowEditing: false, allowFiltering: true,
                        filterBarTemplate: {
                            create: () => { 
                                creationDateElem = document.createElement('input'); 
                                return creationDateElem; 
                                }, 
                        write: (args) => {
                            const persistedValue =
                                args?.value
                                ?? self.workbookGrid?.filterSettings?.columns
                                    ?.find((x: any) => x.field === 'CreationDateTimeString')
                                    ?.value;

                            creationDateObj = new DatePicker({
                                value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                format: 'dd-MM-yyyy',
                                floatLabelType: 'Never',

                                change: (args) => {
                                    const dateValue = DateHelper.DateToString(args.value);

                                    if (dateValue == undefined) {
                                        self.workbookGrid.removeFilteredColsByField(
                                            'CreationDateTimeString'
                                        );
                                    } else {
                                        self.workbookGrid.filterByColumn(
                                            'CreationDateTimeString',
                                            'equal',
                                            dateValue,
                                            undefined,
                                            true
                                        );
                                    }
                                }
                            });
                            creationDateObj.appendTo(creationDateElem); 
                            } 
                        }
                    },
                    { field: 'TaskTypeId', visible: false, allowEditing: true, allowSorting: false},
                    { field: 'TaskType', headerText: 'Type of task',  width: 75, allowEditing: false, type:'dropdownedit', allowFiltering: true, allowSorting: false,
                        filterBarTemplate: self.templateTaskTypeDropDown('TaskTypeId', taskTypesForFilters)},
                    { field: 'Title', headerText: 'Title', width: 200, allowEditing: false},
                    { field: 'LinkType', headerText: 'Linked to',  width: 65, allowEditing: false, filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.workbookGrid, 'LinkType', Object.keys(TaskLinkTypes).filter(key => isNaN(Number(key))), 
                        (args) => {
                        if (args.value !== 'All') {
                            self.workbookGrid.filterByColumn("LinkType", 'equal', args.value, undefined, true);
                        } else {
                            self.workbookGrid.removeFilteredColsByField("LinkType");
                        }
                    })},
                    { field: 'LinkName', headerText: '',  width: 150, allowEditing: false, template: '${getTaskItemLinkName(data.LinkType, data.LinkName, data.LinkId)}'},
                    
                    { field: 'AssignedOperatorId', visible: false, allowEditing: true, allowSorting: false},
                    {
                        field: 'AssignedOperator', headerText: 'Operator', width: 125, allowEditing: true, type:'dropdownedit', allowFiltering: true, allowSorting: false,
                        filterBarTemplate: self.templatePurchasersDropDown('AssignedOperatorId', purchasersForFilters),
                    },
                    { field: 'Status', headerText: 'Status', width: 75, allowSorting: false, allowEditing: false, allowFiltering: true, filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.workbookGrid, 'StatusText', Object.keys(TaskStatus).filter(key => isNaN(Number(key))), 
                        (args) => {
                        if (args.value !== 'All') {
                            self.workbookGrid.filterByColumn("Status", 'equal', args.value, undefined, true);
                        } else {
                            self.workbookGrid.removeFilteredColsByField("Status");
                        }
                    })},                    
                    { field: 'StartDate', headerText: 'Start date', width: 90, allowEditing: false, allowFiltering: true, editType: 'datetimepickeredit',
                        filterBarTemplate: {
                            create: () => { 
                                startDateElem = document.createElement('input'); 
                                return startDateElem; 
                                }, 
                                write: (args) => {
                                const persistedValue =
                                    args?.value
                                    ?? self.workbookGrid?.filterSettings?.columns
                                        ?.find((x: any) => x.field === 'StartDate')
                                        ?.value;

                                startDateObj = new DatePicker({
                                    value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                    format: 'dd-MM-yyyy',
                                    floatLabelType: 'Never',

                                    change: (eventArgs) => {
                                        const dateValue = DateHelper.DateToString(eventArgs.value);

                                        if (dateValue == undefined) {
                                            self.workbookGrid.removeFilteredColsByField('StartDate');
                                        } else {
                                            self.workbookGrid.filterByColumn(
                                                'StartDate',
                                                'equal',
                                                dateValue,
                                                undefined,
                                                true
                                            );
                                        }
                                    }
                                });
                                startDateObj.appendTo(startDateElem); 
                            } 
                        }
                    },
                    { field: 'FinishDate', headerText: 'Finished date', width: 90, allowEditing: false, allowFiltering: true, editType: 'datetimepickeredit',
                        filterBarTemplate: {
                            create: () => { 
                                finishDateElem = document.createElement('input'); 
                                return finishDateElem; 
                                }, 
                                write: (args) => {
                                    const persistedValue =
                                        args?.value
                                        ?? self.workbookGrid?.filterSettings?.columns
                                            ?.find((x: any) => x.field === 'FinishDate')
                                            ?.value;

                                    finishDateObj = new DatePicker({
                                        value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                        format: 'dd-MM-yyyy',
                                        floatLabelType: 'Never',

                                        change: (eventArgs) => {
                                            const dateValue = DateHelper.DateToString(eventArgs.value);

                                            if (dateValue == undefined) {
                                                self.workbookGrid.removeFilteredColsByField('FinishDate');
                                            } else {
                                                self.workbookGrid.filterByColumn(
                                                    'FinishDate',
                                                    'equal',
                                                    dateValue,
                                                    undefined,
                                                    true
                                                );
                                            }
                                        }
                                    });
                                finishDateObj.appendTo(finishDateElem); 
                            } 
                        }
                    },
                    { field: 'DueDateValue', headerText: 'Due date', width: 100, allowEditing: true, allowFiltering: true, editType: 'datetimepickeredit',
                        edit: { 
                            params: {
                                format:'dd-MM-yyyy HH:mm',
                            }
                        },
                        filterBarTemplate: {
                            create: () => { 
                                dueDateElem = document.createElement('input'); 
                                return dueDateElem; 
                            }, 
                            write: (args) => {
                                const persistedValue =
                                    args?.value
                                    ?? self.workbookGrid?.filterSettings?.columns
                                        ?.find((x: any) => x.field === 'DueDateValue')
                                        ?.value;

                                dueDateObj = new DatePicker({
                                    value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                    format: 'dd-MM-yyyy',
                                    floatLabelType: 'Never',

                                    change: (eventArgs) => {
                                        const dateValue = DateHelper.DateToString(eventArgs.value);

                                        if (dateValue == undefined) {
                                            self.workbookGrid.removeFilteredColsByField('DueDateValue');
                                        } else {
                                            self.workbookGrid.filterByColumn(
                                                'DueDateValue',
                                                'equal',
                                                `${dateValue} 00:00`,
                                                undefined,
                                                true
                                            );
                                        }
                                    }
                                });
                                dueDateObj.appendTo(dueDateElem); 
                            } 
                        }
                    },
                    { field: '', headerText: '',  width: 65, allowEditing: false, template: '${getTaskButtons(data.Id, data.Status)}'},
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: true,
                allowSelection: false,
                allowResizing: false,
                enablePersistence: true,
                queryCellInfo: customiseCell,
                recordClick: (e) => {
                    var parsedTarget = $(e.target);
                    if(parsedTarget.is('input') || parsedTarget.is('a') || (parsedTarget.is('button') || parsedTarget.parent().is('button'))) {
                        return;
                    }

                    workloadContainer.find(`input[data-item-id='${e.rowData.Id}']`).trigger('click');
                },
                recordDoubleClick: (e) => {
                    self.startSingleAssign(e.rowData.Id);

                    return;
                },
                actionBegin: (args) => {
                    if (!this.workbookGrid) {
                        return;
                    }

                    if (SyncfusionGridHelper.isFilterAction(args)) {
                        this.workbookGrid.pageSettings.currentPage = 1;
                    }
                },
                //actionComplete: actionComplete,
                pageSettings: { pageSize: 50 },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')
    
                    loadingContainer.addClass('d-none');
                    workloadContainer.removeClass('d-none');
                },
                dataBound: () => {
                    selectedRowIds = [];
                    workloadContainer.find('input[data-item-id]').each((index, element) => {
                        $(element).off('change').on('change', function() {
                            var itemId = $(element).data('item-id');
                            if($(element).is(':checked')) {
                                massAssignButton.prop('disabled', false);
                                selectedRowIds.push(itemId);
                            }
                            else {
                                const index = selectedRowIds.indexOf(itemId);
                                if (index > -1) {
                                    selectedRowIds.splice(index, 1); // 2nd parameter means remove one item only
                                }
            
                                if(selectedRowIds.length <= 0) {
                                    massAssignButton.prop('disabled', true);
                                }
                            }
                        });
                    });

                    workloadContainer.find('button[data-action="edit-task"]').each((index, element) => {
                        var editButton = $(element);
                        editButton.off('click').on('click', () => {
                            var taskId = editButton.data('task-id');
                            self.addOrUpdateTaskModalHelper.load(`?taskId=${taskId}&handler=AddOrUpdateTask`, undefined, () => {
                                if(self.addOrUpdateTaskManager == undefined) {
                                    self.addOrUpdateTaskManager = new AddOrUpdateTaskPopupManager(self.addOrUpdateTaskModalHelper.getModalContainer());
                                }

                                self.addOrUpdateTaskManager.initialize();
                            });
                        })
                    })


                    workloadContainer.find('button[data-action="remove-task"]').each((index, element) => {
                        var deleteButton = $(element);
                        deleteButton.off('click').on('click', () => {
                            var taskId = deleteButton.data('task-id');
                            new ConfirmModal().initialize('Remove task', 'Are you sure you want to remove this task?</br>This action cannot be reverted.', () => {
                                TaskManagerDataService.removeTask(taskId, (result) => {
                                    if(result == true) {
                                        var index = self.workbookGrid.getRowIndexByPrimaryKey(taskId);
                                        var row = self.workbookGrid.getRowByIndex(index);
                                        $(row).remove();
                                    }
                                })
                            }, () => {
                            }, 'Confirm', 'Cancel')
                            
                        })
                    })

                    workloadContainer.find('button[data-action="start-task"]').each((index, element) => {
                        var startButton = $(element);
                        startButton.off('click').on('click', () => {
                            var taskId = startButton.data('task-id');
                            new ConfirmModal().initialize('Start task', 'Please confirm that you want to start this task.</br>This action cannot be reverted.', () => {
                                TaskManagerDataService.startTask(taskId, (result) => {
                                    if(result == true) {
                                        self.workbookGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                                        selectedRowIds = [];
                                        massAssignButton.prop('disabled', true);
                                    }
                                })
                            }, () => {
                            }, 'Confirm', 'Cancel')
                            
                        })
                    })

                    workloadContainer.find('button[data-action="finish-task"]').each((index, element) => {
                        var finishButton = $(element);
                        finishButton.off('click').on('click', () => {
                            var taskId = finishButton.data('task-id');
                            self.finishTaskModalHelper.load(`?taskId=${taskId}&handler=FinishTask`, undefined, () => {
                                if(self.finishTaskManager == undefined) {
                                    self.finishTaskManager = new FinishTaskPopupManager(self.finishTaskModalHelper.getModalContainer());
                                }

                                self.finishTaskManager.initialize();
                            });
                        })
                    })
                }
            });
            self.workbookGrid.appendTo('#WorkloadTaskOverviewGrid');

            function customiseCell(args: QueryCellInfoEventArgs) {
                if(((args.column)as Column).field === 'DueDateValue') {
                    if(args.data != undefined) {
                        let status : any = args.data['DueDateStatus'];
                        let dueDateToday : any = args.data['DueDateToday'];

                        if(status === 'EXPIRED') {
                            ((args.cell)as Element).classList.add('bg-light-red');
                        }
                        else if(status === 'COMPLETED') {
                            ((args.cell)as Element).classList.add('bg-light-green');
                        }

                        else if(status === 'COMPLETED') {
                            ((args.cell)as Element).classList.add('bg-light-green');
                        }
                        else {
                            if(dueDateToday == 'true' || dueDateToday == 'True' || dueDateToday == true) {
                                ((args.cell)as Element).classList.add('bg-light-yellow');
                            }
                        }
                    }
                }
            }
        });

        massAssignButton.off('click').on('click', () => {
            if(selectedRowIds.length <= 0) {
                return;
            }

            self.massAssignModalHelper.loadWithPost('?handler=StartTaskMassAssign', {
                "SelectedTaskIds": selectedRowIds
            }, undefined, () => {
                if(self.massAssignManager == undefined) {
                    self.massAssignManager = new TaskMassAssignPopupManager(self.massAssignModalHelper.getModalContainer());
                }

                self.massAssignManager.initialize();
            });
        });

        (<any>window).initializeTaskMassAssign = () => {
            if(self.massAssignModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                selectedRowIds = [];
                massAssignButton.prop('disabled', true);
            }
            else {
                self.massAssignManager.initialize();
            }
        }

        addTaskButton.off('click').on('click', () => {

            self.addOrUpdateTaskModalHelper.load('?handler=AddOrUpdateTask', undefined, () => {
                if(self.addOrUpdateTaskManager == undefined) {
                    self.addOrUpdateTaskManager = new AddOrUpdateTaskPopupManager(self.addOrUpdateTaskModalHelper.getModalContainer());
                }

                self.addOrUpdateTaskManager.initialize();
            });
        });

        (<any>window).initializeAddOrUpdateTask = () => {
            if(self.addOrUpdateTaskModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                selectedRowIds = [];
                massAssignButton.prop('disabled', true);
            }
            else {
                self.addOrUpdateTaskManager.initialize();
            }
        }

        (<any>window).initializeFinishTask = () => {
            if(self.finishTaskModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                selectedRowIds = [];
                massAssignButton.prop('disabled', true);
            }
            else {
                self.finishTaskManager.initialize();
            }
        }

        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var clearFiltersButton = toolbar.find('#clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.workbookGrid.pageSettings.currentPage = 1;
                self.workbookGrid.clearFiltering();
                self.workbookGrid.refreshHeader();
                selectedRowIds = [];
            })
        }
    }
    
    private startSingleAssign(workloadItemId) {
        var self = this;

        self.massAssignModalHelper.loadWithPost('?handler=StartTaskMassAssign', {
            "SelectedTaskIds": [workloadItemId]
        }, undefined, () => {
            if(self.massAssignManager == undefined) {
                self.massAssignManager = new TaskMassAssignPopupManager(self.massAssignModalHelper.getModalContainer());
            }

            self.massAssignManager.initialize();
        });
    }

    private templatePurchasersDropDown(column: string, options: any[]) {
        const self = this;

        let dropdown: HTMLSelectElement;
        let dropdownList: DropDownList;

        const getPersistedFilterValue = (): string | undefined => {
            const filterColumn = self.workbookGrid?.filterSettings?.columns
                ?.find((x: any) => x.field === column);

            return filterColumn?.value?.toString();
        };

        const dropdownOptions = {
            create: () => {
                dropdown = document.createElement('select');
                dropdown.id = column;

                const allOption = document.createElement('option');
                allOption.value = 'All';
                allOption.innerText = '<All>';
                dropdown.appendChild(allOption);

                options.forEach((item) => {
                    const option = document.createElement('option');
                    option.value = item?.purchaserId?.toString();
                    option.innerText = item?.purchaserName?.toString();
                    dropdown.appendChild(option);
                });

                return dropdown;
            },

            write: (args) => {
                const value =
                    args?.value?.toString()
                    ?? getPersistedFilterValue()
                    ?? 'All';

                dropdownList = new DropDownList({
                    value: value,

                    change: (args) => {
                        if (args.value !== 'All') {
                            self.workbookGrid.filterByColumn(
                                column,
                                'equal',
                                args.value,
                                undefined,
                                true
                            );
                        } else {
                            self.workbookGrid.removeFilteredColsByField(column);
                        }
                    }
                });

                dropdownList.appendTo(dropdown);
            }
        };

        return dropdownOptions;
    }

    private templateTaskTypeDropDown(column: string, options: any[]) {
        const self = this;

        let dropdown: HTMLSelectElement;
        let dropdownList: DropDownList;

        const getPersistedFilterValue = (): string | undefined => {
            const filterColumn = self.workbookGrid?.filterSettings?.columns
                ?.find((x: any) => x.field === column);

            return filterColumn?.value?.toString();
        };

        const dropdownOptions = {
            create: () => {
                dropdown = document.createElement('select');
                dropdown.id = column;

                const allOption = document.createElement('option');
                allOption.value = 'All';
                allOption.innerText = '<All>';
                dropdown.appendChild(allOption);

                options.forEach((item) => {
                    const option = document.createElement('option');
                    option.value = item?.id?.toString();
                    option.innerText = item?.description?.toString();
                    dropdown.appendChild(option);
                });

                return dropdown;
            },

            write: (args: any) => {
                const value =
                    args?.value?.toString()
                    ?? getPersistedFilterValue()
                    ?? 'All';

                dropdownList = new DropDownList({
                    value: value,

                    change: (args: any) => {
                        if (args.value !== 'All') {
                            self.workbookGrid.filterByColumn(
                                column,
                                'equal',
                                args.value,
                                undefined,
                                true
                            );
                        } else {
                            self.workbookGrid.removeFilteredColsByField(column);
                        }
                    }
                });

                dropdownList.appendTo(dropdown);
            }
        };

        return dropdownOptions;
    }
}